import React, {Component, Fragment} from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import ConsequencesCell from './consequence_cell';

export default class ConsequencesTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      row: this.props.row
    }

    var risk_type = ""
    if(this.props.isNewRisk) {
      risk_type = "new_"
    }

    const { financial, safety, occ_health, reputation, environment, legal, community,
            financial1, financial2, financial3, financial4, financial5,
            safety1, safety2, safety3, safety4, safety5,
            occ_health1, occ_health2, occ_health3, occ_health4, occ_health5,
            reputation1, reputation2, reputation3, reputation4, reputation5,
            environment1, environment2, environment3, environment4, environment5,
            legal1, legal2, legal3, legal4, legal5,
            community1, community2, community3, community4, community5,
            insignificant_consequence, minor_consequence, moderate_consequence, high_consequence, major_consequence,
            consequence_rating } = this.props.translations

    this.consequences = [
      {
        dataField: "consequence_rating",
        text: consequence_rating,
        rows: [ insignificant_consequence, minor_consequence, moderate_consequence, high_consequence, major_consequence ]
      },
      {
        dataField: risk_type + "financial",
        text: financial,
        rows: [ financial1, financial2, financial3, financial4, financial5 ]
      },
      {
        dataField: risk_type + "safety",
        text: safety,
        rows: [ safety1, safety2, safety3, safety4, safety5 ]
      },
      {
        dataField: risk_type + "health",
        text: occ_health,
        rows: [ occ_health1, occ_health2, occ_health3, occ_health4, occ_health5 ]
      },
      {
        dataField: risk_type + "reputation",
        text: reputation,
        rows: [ reputation1, reputation2, reputation3, reputation4, reputation5 ]
      },
      {
        dataField: risk_type + "environmental",
        text: environment,
        rows: [ environment1, environment2, environment3, environment4, environment5 ]
      },
      {
        dataField: risk_type + "legal",
        text: legal,
        rows: [ legal1, legal2, legal3, legal4, legal5 ]
      },
      {
        dataField: risk_type + "community",
        text: community,
        rows: [ community1, community2, community3, community4, community5 ]
      },
    ]

    this.consequenceRatingStyle = {
      width: '150px',
      textAlign: "center",
      cursor: "default",
      fontWeight: "bold"
    }

    this.onEscape = this.onEscape.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      row: nextProps.row
    })
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.onEscape, false);
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.onEscape, false);
  }

  onEscape = (event) => {
    if(event.keyCode === 27) {
      this.onClose()
    }
  }

  consequenceFormatter = (cell, colIndex) => {
    const cellProps = {
      colIndex: colIndex
    }
    return <ConsequencesCell {...cellProps}>{ cell }</ConsequencesCell>
  }

  tableColumns = () => {
    var columns = []
    for(var i in this.consequences) {
      const colIndexCtr = i
      columns.push(
        {
          dataField: this.consequences[i].dataField,
          text: this.consequences[i].text,
          attrs: (cell, row, rowIndex, colIndex) => ({ 'column_index': colIndex, 'title': cell }),
          style: (cell, row, rowIndex, colIndex) => {
            var dataField = this.consequences[colIndex].dataField
            if (dataField === "consequence_rating") return this.consequenceRatingStyle;

            var style = {
              width: '150px',
              textAlign: "left",
              cursor: "pointer",
            }
            if(this.state.row[dataField].toString() === (rowIndex + 1).toString()) {
              style["backgroundColor"] = "lightgreen"
            }
            return style
          },
          headerStyle: (column, colIndex) => {
            var style = {
              width: '150px',
              textAlign: "center",
              cursor: "default"
            }
            return style
          },
          formatter: (cell, row) => this.consequenceFormatter(cell, colIndexCtr)
        }
      )
    }
    return columns
  }

  tableRows = () => {
    var rows = []
    var rowsCount = this.consequences[0].rows.length

    for(var x = 0; x < rowsCount; x++) {
      var row = {}
      for(var y in this.consequences) {
        var dataField = this.consequences[y].dataField
        row[dataField] = this.consequences[y].rows[x]
      }
      rows.push(row)
    }
    return rows
  }

  onClose = () => {
    this.props.onUpdate(this.state.row[this.props.column.dataField])
  }

  render() {
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        if (!e.target.hasAttribute("column_index")) return;
        var colIndex = e.target.getAttribute("column_index")
        var column = this.tableColumns()[colIndex]
        var dataField = column.dataField
        if (dataField === "consequence_rating") return;
        var oldValue = this.props.row[dataField].toString()
        var newValue = (rowIndex + 1).toString()
        if (oldValue.length !== 0 && oldValue === newValue) {
          newValue = ''
        }
        var state_row = this.state.row

        state_row[dataField] = newValue
        this.setState({
          row: state_row
        })
        this.props.changeHandler(oldValue, newValue, state_row, column)
      }
    }

    const { close, final_consequence, current_consequence } = this.props.translations
    return (
      <div className="consequences-modal">
        <div className="consequences-overlay" onClick={ () => this.onClose() } />
        <div className="consequences-content">
          <div className="consequences-header">
            <b>{(this.props.isNewRisk? final_consequence : current_consequence)}</b>
            <a style={{float: "right", cursor: "pointer"}} onClick={ () => this.onClose() }>{close}</a>
          </div>
          <BootstrapTable
            classes="consequences-table"
            keyField="id"
            columns={this.tableColumns()}
            data={this.tableRows()}
            rowEvents={rowEvents}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/consequences_table.js